import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon } from "../../components"

/* REST API */
import { prepare } from "../../api/Organization"

Modal.setAppElement("#root")


/* The empty filter — the table opens on it */
export const INITIAL_FILTER = { visible: "all", subscription: "all", serviceMode: "all", cityID: 0, sort: "new" }

/* Is the point shown to the clients */
const VISIBLE = [
    { key: "all", text: "Все" },
    { key: "visible", text: "Включены" },
    { key: "hidden", text: "Отключены" }
]

/* Has the point paid for the term */
const SUBSCRIPTION = [
    { key: "all", text: "Все" },
    { key: "subscribed", text: "Оплачена" },
    { key: "expired", text: "Не оплачена" }
]

/* By the clock or by the tickets of a queue */
const MODES = [
    { key: "all", text: "Все" },
    { key: "TIME_BASED", text: "Запись по времени" },
    { key: "QUEUE_BASED", text: "Очередь" }
]

/* How the table is sorted */
const SORTS = [
    { key: "new", text: "Сначала новые" },
    { key: "old", text: "Сначала старые" },
    { key: "name", text: "По названию" },
    { key: "bookings", text: "По количеству записей" },
    { key: "subscription", text: "По сроку подписки" }
]


/* Widget Filter Modal — what the table of the points is narrowed down by.
   It is opened by the reference: this._filter.open(filter) */
class FilterModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            filter: { ...INITIAL_FILTER },
            cities: []
        }
    }

    componentDidMount = () => {

        /* The cities are asked for once — the list of them does not change while the panel is open */
        prepare().then(response => {
            if (response && response.status === 200) {
                this.setState({ cities: response.data.cities })
            }
        }).catch(() => this.setState({ cities: [] }))
    }

    /* Open the filter on what the table is showing now */
    open = filter => {
        this.setState({ visible: true, filter: { ...INITIAL_FILTER, ...filter } })
    }

    /* Close the filter */
    close = () => {
        this.setState({ visible: false })
    }

    /* Choose one value of the filter */
    set = (key, value) => {
        this.setState(previous => ({ filter: { ...previous.filter, [key]: value } }))
    }

    /* Give the chosen filter to the table */
    apply = () => {

        const { filter } = this.state
        const { onApply } = this.props

        this.setState({ visible: false })
        onApply(filter)
    }

    /* Drop everything back to the empty filter */
    reset = () => {

        const { onApply } = this.props

        this.setState({ visible: false, filter: { ...INITIAL_FILTER } })
        onApply({ ...INITIAL_FILTER })
    }

    /* One row of the filter — a name and the values it is chosen between */
    _row = (text, key, values) => {

        /* Fields */
        const { filter } = this.state

        return (
            <div className="filter-modal-row">

                <div className="filter-modal-row-text">{text}</div>

                <div className="filter-modal-chips">
                    {values.map(value =>
                        <div
                            key={`${value.key}`}
                            onClick={() => this.set(key, value.key)}
                            className={`filter-modal-chip ${filter[key] === value.key ? "active" : ""}`}
                        >
                            {value.text}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, filter, cities } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="filter-modal"
                overlayClassName="filter-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="filter-modal-header">
                    <h2>Фильтры</h2>
                    <div onClick={this.close} className="filter-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="filter-modal-body">

                    {this._row("Статус", "visible", VISIBLE)}
                    {this._row("Подписка", "subscription", SUBSCRIPTION)}
                    {this._row("Режим работы", "serviceMode", MODES)}

                    {cities.length > 0 &&
                        <div className="filter-modal-row">

                            <div className="filter-modal-row-text">Город</div>

                            <div className="filter-modal-chips">

                                <div
                                    onClick={() => this.set("cityID", 0)}
                                    className={`filter-modal-chip ${parseInt(filter.cityID) === 0 ? "active" : ""}`}
                                >
                                    Все
                                </div>

                                {cities.map(city =>
                                    <div
                                        key={`${city.id}`}
                                        onClick={() => this.set("cityID", parseInt(city.id))}
                                        className={`filter-modal-chip ${parseInt(filter.cityID) === parseInt(city.id) ? "active" : ""}`}
                                    >
                                        {city.name}
                                    </div>
                                )}

                            </div>

                        </div>
                    }

                    {this._row("Сортировка", "sort", SORTS)}

                </div>

                <div className="filter-modal-footer">
                    <div onClick={() => this.reset()} className="filter-modal-button light">Сбросить</div>
                    <div onClick={() => this.apply()} className="filter-modal-button">Показать</div>
                </div>

            </Modal>
        )
    }
}

export default FilterModal
